import { Box, css } from '@mui/material'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.gray[300]};
    border-radius: 10px;
    display: flex;

    @media (max-width: ${theme.screenSizes.laptop}) {
      width: 100%;
      flex-direction: column;
    }
  `}
`

export const MenuContent = styled(Box)`
  ${({ theme }) => css`
    width: 264px;
    min-height: 300px;
    border-right: 1px solid ${theme.colors.gray[300]};
    background: ${theme.colors.gray[100]};
    border-radius: 10px 0 0 10px;

    @media (max-width: ${theme.screenSizes.laptop}) {
      width: 100%;
      flex-direction: column;
      border-radius: 10px 10px 0 0;
      border-right: none;
      border-bottom: 1px solid ${theme.colors.gray[300]};
    }
  `}
`

export const Search = styled(Box)`
  padding: 39px 16px 24px 16px;
`

export const Menus = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const Menu = styled(Box)<{ isSelected: boolean }>`
  ${({ theme, isSelected }) => css`
    height: 48px;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    color: ${theme.colors.secondary};
    padding: 0 48px;
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 12px;

    &:hover {
      transition: all ease 0.3s;
      background: ${theme.colors.gray[300]};
    }

    ${isSelected &&
    css`
      background: ${theme.colors.primary};
      color: ${theme.colors.lightest};

      &:hover {
        background: ${theme.colors.primary};
      }
    `}

    @media (max-width: ${theme.screenSizes.laptop}) {
      padding: 0 16px;
    }
  `}
`

export const ArrowIcon = styled(Box)`
  margin-left: auto;
  display: flex;
  align-items: center;
`

export const SubMenu = styled(Menu)`
  font-size: 14px;
  font-weight: 400;
`

export const Content = styled(Box)`
  ${({ theme }) => css`
    width: calc(100% - 264px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (max-width: ${theme.screenSizes.laptop}) {
      width: 100%;
    }
  `}
`

export const TopContent = styled(Box)`
  ${({ theme }) => css`
    padding: 48px 56px 56px 56px;
    display: flex;
    flex-direction: column;
    gap: 32px;

    @media (max-width: ${theme.screenSizes.laptop}) {
      padding: 24px 16px;
    }
  `}
`

export const BottomContent = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    justify-content: flex-end;
    gap: 32px;
    padding: 0 56px 56px 56px;

    @media (max-width: ${theme.screenSizes.laptop}) {
      padding: 0 16px 16px 16px;
      margin-top: 16px;
      gap: 16px;
    }
  `}
`

export const Options = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Label = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    color: ${theme.colors.secondary};
    display: flex;
    align-items: center;
    gap: 12px;

    svg {
      width: 24px;
      height: 24px;
      color: ${theme.colors.secondary};
    }
  `}
`
